<template>
	<div class="flex flex-col items-center justify-center gap-4">
		<h3 class="text-center text-5xl font-sarv">
			<slot name="title" />
		</h3>

		<p class="text-center lg:text-justify">
			<slot name="description" />
		</p>
	</div>
</template>
